// tslint:disable:no-reference
/// <reference path="../../../types/svg-react.d.ts" />

import React from "react"

import ShuffleIcon from "../../resources/icons/shuffle.r.svg"

import { LocalIconFlip } from "./LocalIconFlip"
import { LocalIconName } from "./LocalIconName"

ShuffleIcon.displayName = "ShuffleIcon"

export interface LocalIcon {
  /** React component inlined from the SVG asset at build time. */
  component: React.ComponentType<React.SVGProps<SVGSVGElement>>

  /** How the glyph behaves in RTL locales. */
  flip: LocalIconFlip
}

/**
 * Registry of icons implemented in this package rather than taken from Alchemy.
 *
 * The SVG assets live in `src/resources/icons` and MUST use the `.r.svg`
 * suffix, which is what makes the build inline them as React components. Each
 * asset MUST paint with `fill="currentColor"` and carry no `width`/`height`, so
 * that `IconColor` and `IconSize` stay in control.
 */
export const LocalIconMap: Record<LocalIconName, LocalIcon> = {
  shuffle: { component: ShuffleIcon, flip: "rtl" },
}

export function isLocalIconName(name: string): name is LocalIconName {
  return Object.prototype.hasOwnProperty.call(LocalIconMap, name)
}
